
import { INewsResponse, ISingleNewsResponse } from "@/types/news.type";
import { BASE_URL, STRAPI_HEADERS } from "./strapi-config";

export const getAllNews = (
  locale: string,
  category: string | null,
  featured: boolean
): Promise<INewsResponse> => {
  return fetch(
    `${BASE_URL}/news?locale=${encodeURIComponent(locale)}&populate[0]=news_tags&populate[1]=localizations&populate[2]=poster&populate[3]=news_category${
      category ? `&filters[news_category][name][$eq]=${encodeURIComponent(category)}` : ""
    }${featured ? `&filters[featured][$eq]=true` : ""}`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: INewsResponse) => {
      return data;
    });
};

export const getSingleNews = (
  locale: string,
  id: string
): Promise<ISingleNewsResponse> => {
  return fetch(
    `${BASE_URL}/news/${encodeURIComponent(id)}?locale=${encodeURIComponent(locale)}&populate[0]=news_tags&populate[1]=localizations&populate[2]=poster&populate[3]=news_category`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: ISingleNewsResponse) => {
      return data;
    });
};
